<template>
  <div>
    <div>
      <div>
        <InputSearch
          class="mb-3"
          @clickSearch="onSearch"
          :search="search"
          :placeholder="'ค้นหา'"
          showDateRangeSearch
        />
        <v-layout row wrap dense class="mb-3">
          <v-flex xs6 style="display: flex; align-items: center">
            <Typography h2 bold label="ข้อมูลโครงการ" />
          </v-flex>
          <v-flex xs6 style="display: flex; align-items: flex-end; justify-content: flex-end">
            <div class="text-xs-right" style="display: flex; align-items: flex-end">
              <v-btn
                variant="outlined"
                v-tooltip="'เพิ่ม'"
                @click="showAdd"
                :loading="loading"
                icon
                color="#BECCDB"
                style="border-radius: 50% !important"
              >
                <img src="/static/img/Add.png" alt class="responsive-img" style="height: 20px" />
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </div>
      <v-layout class="my-5" justify-center v-if="loading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <div v-else>
        <v-data-table
          :headers="headers"
          :items="desserts"
          hide-actions
          select-all
          item-key="name"
          class="fixTable"
        >
          <template v-slot:headers="props">
            <tr style="background-color: #152d53; color: white">
              <th
                style="background-color: #152d53; color: yellow"
                v-for="(header, k) in props.headers"
                :key="header.text + k"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : ''
                ]"
                @click="changeSort(header.value)"
              >
                <div>
                  {{ header.text }}
                </div>
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr class="py-3 depatable">
              <td class="text-left">
                <Typography
                  style="width: 160px;"
                  h5
                  :label="props.item.extraid ? props.item.extraid : '-'"
                />
              </td>
              <td class="text-xs-center forimage">
                <div style="width: 170px;padding:0;">
                  <v-img
                    @click="
                      showImg = true
                      showImgUrl = props.item.projectimg
                    "
                    :src="props.item.projectimg"
                  />
                </div>
              </td>
              <td class="text-left">
                <Typography
                  style="width: 280px;"
                  h5
                  :label="props.item.projectname ? props.item.projectname : '-'"
                />
              </td>
              <td class="text-xs-center">
                {{ props.item.projecteffdate | DateFormat('DD/MM/YYYY') }}
              </td>
              <td class="text-xs-center">
                {{ props.item.projectenddate | DateFormat('DD/MM/YYYY') }}
              </td>
              <td class="text-center">
                <div
                  v-if="props.item.publish_status"
                  class="draftBtnActive"
                  @click.stop="changeDraft(props.item)"
                >
                  PUBLISH
                </div>
                <div v-else class="draftBtn" @click.stop="changeDraft(props.item)">
                  DRAFT
                </div>
              </td>
              <td class="text-left">
                <Typography
                  style="width: 280px;"
                  h5
                  :label="
                    getTypeData(props.item.typeid) ? getTypeData(props.item.typeid).typename : '-'
                  "
                />
              </td>
              <td class="text-left">
                <div style="display: flex;" v-for="(project, p) in props.item.preprojects" :key="p">
                  <span
                    style="
                      display: flex;
                      align-items: center;
                      width: 10px;
                      height: 10px;
                      margin-top: 9px;
                      font-size: 22px;"
                    v-if="project.projectname"
                    >•</span
                  >
                  <Typography
                    v-if="project.projectname"
                    style="width: 280px;margin-left: 2px;"
                    h5
                    :label="project.projectname ? `${project.projectname}` : '-'"
                  />
                </div>
              </td>
              <td style="white-space: nowrap" @click.stop="" class="text-xs-center">
                <TooltipTable
                  :datas="props"
                  @modalEdit="showEdit(props.item), (isEdit = true)"
                  @Delete="deleteProject(props.item.id)"
                  showDelete
                ></TooltipTable>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div>
          <v-dialog v-model="editModal" persistent width="590px">
            <project-info-edit
              :edittype="edittype"
              @closemodal="closemodal"
              @onCreate="onCreate"
              @onUpdate="onUpdate"
              v-if="editModal"
              v-model="inputEdit"
            ></project-info-edit>
          </v-dialog>
        </div>
        <v-dialog v-model="showImg" width="800px">
          <v-card v-if="showImg">
            <div class="text-xs-right">
              <v-btn icon @click="showImg = false"><v-icon>close</v-icon></v-btn>
            </div>

            <div><v-img :src="showImgUrl"></v-img></div>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <Paginations
      @clickPagination="changepage"
      @sortPage="sortPage"
      :pageCount="pageCount"
      :numberPage="numberPage"
      :page="page"
    />
  </div>
</template>

<script>
import InputSearch from '@/components/elements/InputSearch.vue'
import Paginations from '@/components/elements/Paginations.vue'
import ProjectInfoEdit from './ProjectInfoEdit.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import Typography from '@/components/elements/Typography.vue'
import TooltipTable from '@/components/elements/TooltipTable.vue'
import Button from '@/components/elements/Button.vue'
import moment from 'moment'
export default {
  components: {
    ProjectInfoEdit,
    Multiselect,
    InputSearch,
    TooltipTable,
    Paginations,
    Typography,
    Button
  },

  data() {
    return {
      page: 1,
      numberPage: {
        page: undefined
      },
      pageTotal: 0,
      loading: true,
      search: { projectname: '', projecteffdate: '', projectenddate: '', projecttype: '' },
      pagination: {
        sortBy: 'memberid',
        descending: false,
        rowsPerPage: 50
      },
      showSearch: false,
      showImgUrl: '',
      showImg: false,
      filter: {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        email: '',
        phoneno: '',
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        status: '',
        tags: '',
        lineid: '',
        school: '',
        province: '',
        uu_register_status: '',
        specialcondition: '',
        statustype: 'includes'
      },
      test: false,
      usersdata: [],
      inputEdit: {},
      editModal: false,
      edittype: '',
      data: [],
      desserts: [],
      exdata: [],
      headers: [
        {
          text: 'รหัสโครงการ',
          align: 'left',
          value: 'projectid'
        },
        {
          text: 'รูปภาพ',
          align: 'left',
          value: 'projectimg'
        },
        {
          text: 'โครงการ',
          align: 'left',
          value: 'projectname'
        },
        {
          text: 'วันที่เริ่มโครงการ',
          align: 'left',
          value: 'createdate'
        },
        {
          text: 'วันที่สิ้นสุดโครงการ',
          align: 'left',
          value: 'enddate'
        },
        {
          text: 'สถานะโครงการ',
          align: 'center',
          value: 'publish_status'
        },
        {
          text: 'ประเภทโครงการ',
          align: 'left',
          value: 'typeid'
        },
        {
          text: 'โครงการที่จำเป็นต้องเข้าร่วมมาก่อน',
          align: 'left',
          value: 'preprojects'
        },
        {
          text: '',
          align: 'center',
          value: ''
        }
      ],
    }
  },
  async mounted() {
    this.loading = true
    await this.getProjectType()

    await this.getAllUsers()
    await this.getProject()
    this.loading = false
  },
  computed: {
    pageCount() {
      if (this.desserts && this.pageTotal) {
        let count = Math.ceil(this.pageTotal / this.pagination.rowsPerPage)
        return count
      } else {
        return 0
      }
    },
    limitCom() {
      return this.pagination.rowsPerPage
    },
    offsetCom() {
      return this.page ? this.page * this.pagination.rowsPerPage - this.pagination.rowsPerPage : this.pagination.rowsPerPage
    },
    ...mapGetters(['selectedBot']),
    optionsType() {
      return this.$store.state.projecttype
    }
  },
  methods: {
    async changeDraft(item) {
      this.$swal
        .fire({
          title:
            '<img src="/static/img/question.png" alt class="responsive-img mt-4" style="height: 73px" />',
          html: `<div class="primary--text fs-16 mt-2 mb-3" style="font-weight:600;">${
            item.publish_status
              ? 'คุณต้องการหยุดเผยแพร่โครงการนี้ใช่หรือไม่'
              : 'คุณต้องการเผยแพร่โครงการนี้ใช่หรือไม่'
          }</div>`,
          showCancelButton: true,
          showCloseButton: true
        })
        .then(async result => {
          if (result.value) {
            let res = await api.changeProjectPublishstatus(item.id, !item.publish_status)
            if (res.status === 200) {
              await this.getProject()
              this.$swal.fire({
                title:
                  '<div class="headline primary--text bold7 fs-24">เปลี่ยนสถานะโครงการสำเร็จ</div>',
                showCancelButton: false,
                showCloseButton: true
              })
            } else {
              this.$swal.fire('เปลี่ยนสถานะโครงการไม่สำเร็จ')
            }
          }
        })
    },
    customLabel(opt) {
      var type = this.optionsType.find(x => {
        return x.id == opt
      })
      if (type) {
        return type.typename
      } else {
        return ''
      }
    },
    async changepage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      this.loading = true
      await this.getProject()
      this.loading = false
    },
    async sortPage(pages) {
      let count = Math.ceil(this.pageTotal / this.pagination.rowsPerPage)
      if (pages == '' || Number(pages <= 0) || pages > Number(count)) return
      this.page = parseInt(pages)
      this.loading = true
      await this.getProject()
      this.loading = false
    },
    async onSearch() {
      this.loading = true
      this.searchloading = true
      this.page = 1
      await this.getProject()
      this.searchloading = false
      this.showSearch = false
      this.loading = false
    },
    async clearSearch() {
      this.search = { projectname: '', projecteffdate: '', projectenddate: '' }
      this.searchloading = true
      await this.getProject()
      this.searchloading = false
      this.showSearch = false
    },
    getTypeData(id) {
      var result = this.$store.state.projecttype.find(el => id == el.id)

      return result
    },
    getProject() {
      return new Promise(resolve => {
        // var data = this.search
        // api.getdepaproject(data, (err, response) => {
        //   if (response.responsecode == 200) {
        //     this.data = response.data
        //     resolve()
        //   }
        // })
        var search = {}
        var countSearch = 0
        for (const [key, value] of Object.entries(this.search)) {
          if (key == 'agencyname' && typeof value == 'object') {
            Object.assign(search, { ['agencyid']: value.id })
          } else if (value) {
            Object.assign(search, { [key]: value })
          }
          if (value && key != 'tags') {
            countSearch++
          }
        }
        console.log('search', search)
        api.getdepaproject(
          {
            // ...search,
            nameAll: search.nameAll,
            projecteffdate: search.startDate ? moment(search.startDate).format('YYYY-MM-DD') : '',
            projectenddate: search.endDate ? moment(search.endDate).format('YYYY-MM-DD') : '',
            pageid: this.selectedBot.pageid,
            limit: this.limitCom,
            offset: this.offsetCom
          },
          (err, response) => {
            this.desserts = response.data
            this.pageTotal = response.total
            console.log('response', response)
            resolve()
          }
        )
      })
    },
    getAllUsers() {
      return new Promise(resolve => {
        var data = {
          pageid: this.selectedBot.pageid,
          admin: true //optionalstatus: //optional เช่น confirm, unconfirmedlimit: //optionaloffset: //optional
        }
        api.getdepamember(data, (err, response) => {
          if (response.responsecode == 200) {
            this.$store.state.usersdata = response.data
          }
          resolve()
        })
      })
    },
    getProjectType() {
      return new Promise(resolve => {
        api.getdepaprojecttype({}, (err, response) => {
          if (response.responsecode == 200) {
            this.$store.state.projecttype = response.data.map(el => {
              return { ...el, typedata: JSON.parse(el.typedata) }
            })
          }
          resolve()
        })
      })
    },
    statusColor(status) {
      if (status == 'Active') return 'green'
      else if (status == 'Inactive') return 'red'
    },
    async deleteProject(id) {
      console.log('id', id)
      this.$swal
        .fire({
          title:
            '<img src="/static/img/delete.png" alt class="responsive-img mt-4" style="height: 73px" />',
          html: `<div class="primary--text fs-16 mt-2 mb-3" style="font-weight:600;">คุณต้องการลบข้อมูลโครงการนี้ใช่หรือไม่?</div>`,
          showCancelButton: true,
          showCloseButton: true
        })
        .then(async result => {
          if (result.value) {
            let res = await api.deletedepaproject({ projectid: id })
            if (res.status === 200) {
              await this.getProject()
              this.$swal.fire({
                type: 'success',
                title: '<div class="headline primary--text bold7 fs-24">ลบข้อมูลสำเร็จ</div>',
                confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
              })
            } else {
              this.$swal.fire('ลบข้อมูลไม่สำเร็จ')
            }
          }
        })
    },
    async onUpdate(item) {
      // var index = this.data.findIndex(el => el.id == item.id)
      // this.$set(this.data, index, item)
      // this.data[index] = item
      await this.getProject()
      this.editModal = false
    },
    async onCreate() {
      // this.data.push(item)
      await this.getProject()
      this.$nextTick(() => {
        this.editModal = false
      })
    },
    closemodal() {
      this.editModal = false
    },
    showEdit(item) {
      this.edittype = 'edit'
      this.inputEdit = item

      this.editModal = true
    },
    showAdd() {
      this.edittype = 'add'
      this.editModal = true
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.draftBtn {
  background-color: #bdbdbd;
  padding: 2px 12px;
  border-radius: 20px;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  width: fit-content;
  margin: auto;
  cursor: pointer;
}
.draftBtnActive {
  background-color: #52c41a;
  padding: 2px 12px;
  border-radius: 20px;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  width: fit-content;
  margin: auto;
  cursor: pointer;
}
.depatable td {
  vertical-align: baseline;
}
.depatable td.forimage {
  vertical-align: baseline !important;
}
.fixTable table.v-table {
  thead {
    tr {
      th:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      th:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
  tbody {
    tr {
      td:not(:last-child) {
        vertical-align: top;
      }
      td:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        background-color: #ffffff;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
        vertical-align: top;
      }
      td:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/projectMaster/ProjectInfo.vue